import * as Yup from "yup";
import {
    dropDownErrorMsg,
    minLengthErrorMsg
} from "../utils/constants/YupErrorMessages";
import {defaultAddressValidationSchema} from "../utils/constants/AddressFields";
import {ascii} from "../utils/utils";

export const validationSchema = defaultAddressValidationSchema.concat(Yup.object().shape({
    honorific: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Honorific Details is required'),
    name: ascii.uppercase().required('Name is required'),
    zipcode: ascii.required('Zipcode is required'),
    // Free-text State/Province, optional - a foreign remittee may not have one.
    state: ascii.nullable(),
    // TIN is a foreign identifier - lengths vary by country, so no length rule at all
    // (BGSS, 16 Sep). The Remittee model is a TextField to match.
    tin_number: ascii.required('TIN Number is required'),
    country_of_remittance: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Country of Remittance'),
    email: ascii.email().nullable(),
    phone: ascii.nullable(),
    phone_code: ascii.nullable(),
    country: ascii.nullable(),
    premise_building_village: ascii.nullable(),
    // Optional for a foreign address - many have no street line.
    road_street: ascii.nullable(),
    // Watches country_of_remittance, not currency - '9999' is a country code, so
    // keyed off currency this condition could never be true and the box was never
    // enforced. Same mistake was in nature_of_remittance_other below.
    country_of_remittance_other: ascii.when('country_of_remittance', {
        is: val => val === '9999',
        then: schema => schema.required('Country of Remittance (Other) is required'),
        otherwise: schema => schema.nullable()
    }),
    currency_of_remittance: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Currency of Remittance'),
    currency_of_remittance_other: ascii.uppercase().when('currency_of_remittance', {
        is: val => val === '99',
        then: schema => schema.required('Currency of Remittance (Other)'),
        otherwise: schema => schema.nullable()
    }),
    nature_of_remittance: ascii.min(4, minLengthErrorMsg).notOneOf(["-1"], dropDownErrorMsg).required('Nature of Remittance'),
    nature_of_remittance_other: ascii.uppercase().when('nature_of_remittance', {
        is: val => val === '16.99',
        then: schema => schema.required('Nature of Remittance (Other) is required'),
        otherwise: schema => schema.nullable()
    }),
    relevant_purpose_code: ascii.min(6, minLengthErrorMsg).notOneOf(["-1"], dropDownErrorMsg).required('Relevant Purpose Code'),
    relevant_purpose_code_detail: ascii.min(12, minLengthErrorMsg).notOneOf(["-1"], dropDownErrorMsg).required('Relevant Purpose Code Detail'),
    // PAN is "if available" for a remittee: an empty box must pass.
    pan: ascii.uppercase().nullable().test('pan-length', 'Length should be 10', value => !value || value.length === 10),
    principal_place_of_business: ascii.uppercase().required('Principal Place of Business is Required'),
    country_of_residence: ascii.notOneOf(["-1"], dropDownErrorMsg).required('Country of Residence'),
    post_office: ascii.required('Post Office is required')
}));